<div class="footer-container">
  @if (showCancelButton) {
    <app-button (pressed)="onCancel()" type="ghost" i18n="@@action.close">Close</app-button>
  }
  <app-button (pressed)="onSave()" [disabled]="isDisabled">
    <mat-icon icon-left>check</mat-icon>
    <ng-container i18n="@@action.save">Save</ng-container>
  </app-button>
</div>
